import { useEffect, useState } from 'react'
import { fetchUserScreens } from '../services/auth/Profile/ProfileApi'

const useUserScreens = () => {
  const [screens, setScreens] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const userId = localStorage.getItem('userId')

  const fetchScreens = async () => {
    setLoading(true)
    setError(null)
    try {
      const screens = await fetchUserScreens(userId)
      setScreens(screens)
    } catch (error) {
      console.error('Error fetching user screens:', error)
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchScreens()
  }, [userId])

  return { screens, loading, error }
}

export default useUserScreens
